/* Sunnoly – révélation douce au défilement (thème Horizon) */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('sn-js');

  var SEL = 'product-card, .collection-card, #MainContent > .shopify-section:not(:first-child) :is(h2, .text-block, .group-block > *)';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('sn-in'); io.unobserve(el);
      // Une fois arrivé, on rend la main aux effets de survol du thème.
      setTimeout(function () { el.classList.remove('sn-reveal', 'sn-in'); el.style.transitionDelay = ''; }, 1300);
    });
  }, { threshold: 0.12 });

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el, i) {
      if (el.dataset.snSeen) return;
      el.dataset.snSeen = '1';
      // Seuls les éléments sous l'écran sont animés : ce qui est déjà visible ne bouge pas.
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('sn-reveal');
        el.style.transitionDelay = (i % 4) * 80 + 'ms';
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  // Produits chargés plus tard (filtres, pagination, recommandations)
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; scan(); }, 250);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
